export const HPrimeIcon = ({ className = "h-4 w-4" }) => (
  <span
    role="img"
    aria-label="HPrime"
    className={`inline-block shrink-0 bg-current ${className}`}
    style={{
      WebkitMask: "url(/brand/hprime-mark.png) center / contain no-repeat",
      mask: "url(/brand/hprime-mark.png) center / contain no-repeat",
    }}
  />
);
